import SettingsTile from "./SettingsTile";

export default SettingsTile;
